import { gql } from '@apollo/client';

export const DELETE_FINDS_MUTATION = gql`
  mutation DeleteFindsMutation($ids: [String!]!) {
    deleteFinds(ids: $ids) {
      ... on DeleteFindsSuccess {
        deletedIds
        skippedIds
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
